import React from 'react'
import styled from 'styled-components'
import Button, { ButtonProps } from '@material-ui/core/Button'
import Link from '../StyledLink'

const StyledComponent = styled(Button)<ILinkButton>`
  line-height: 1;
  max-width: 100%;
` as React.ComponentType<ILinkButton>

const SimpleButton = ({ children, ...props }: ButtonProps) => (
  <StyledComponent {...props}>{children}</StyledComponent>
)

interface ILinkButton extends ButtonProps {
  to?: string
}

const LinkButton = ({ children, ...props }: ILinkButton) => (
  <StyledComponent {...props} component={Link} to={props.to}>
    {children}
  </StyledComponent>
)

export const StyledButton = (props: ILinkButton) =>
  props.to ? <LinkButton {...props} /> : <SimpleButton {...props} />
